import {InputButtonProps} from '../components/input-button';

export const getInputButton =
  <T>(data: Omit<InputButtonProps<T>, 'type'>) =>
  (): InputButtonProps<T> => ({
    ...data,
    type: 'input-button',
  });
